// @flow
import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import Button from '../../components/Button'
import Input from '../../components/Input'
import {
  minPriceOptions,
  maxPriceOptions,
  minAreaOptions,
  minBedOptions,
  minBathOptions
} from '../../data/filters'

type SelectOptions = {
  label: string,
  name: string,
  options: Array<Object>
}

const Select = ({ label, name, options }: SelectOptions) => (
  <div style={{ marginBottom: '1rem' }}>
    <label htmlFor="minprice">{label}</label>
    <Field name={name} component="select" className="form-control">
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.display}
        </option>
      ))}
    </Field>
  </div>
)

type Props = {
  onSubmit: Function,
  handleSubmit: Function,
  submitting: boolean,
  onRequestClose: Function
}

class AlertForm extends Component {
  props: Props

  handleSubmit = (data) => this.props.onSubmit({ alert: data })

  render() {
    const { handleSubmit, submitting, onRequestClose } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div className="modal-header">
          <h5>Property Notification</h5>
          <button
            type="button"
            className="modal-close"
            onClick={onRequestClose}
          >
            &times;
          </button>
        </div>
        <div className="modal-content">
          <Field
            name="keyword"
            label="Keyword"
            placeholder="City/zip"
            component={Input}
            style={{ marginBottom: '1rem' }}
          />
          <div className="row">
            <div className="col-md-6 col-xs-12">
              <Select
                name="minprice"
                label="Min price"
                options={minPriceOptions}
              />
            </div>
            <div className="col-md-6 col-xs-12">
              <Select
                name="maxprice"
                label="Max price"
                options={maxPriceOptions}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-xs-12">
              <Select name="minbeds" label="Beds" options={minBedOptions} />
            </div>
            <div className="col-md-6 col-xs-12">
              <Select name="minbaths" label="Baths" options={minBathOptions} />
            </div>
          </div>
          <Select name="minarea" label="Area" options={minAreaOptions} />
        </div>
        <div className="modal-footer">
          <Button onClick={onRequestClose} type="button">
            Cancel
          </Button>
          <Button color="primary" disabled={submitting} animating={submitting}>
            Submit
          </Button>
        </div>
      </form>
    )
  }
}

const validate = (values) => {
  const errors = {}
  if (!values.keyword) {
    errors.keyword = 'Please enter keyword'
  }
  return errors
}

export default reduxForm({
  form: 'alert',
  validate
})(AlertForm)



// WEBPACK FOOTER //
// ./src/components/AlertForm/index.js